export enum FeatureFlags {
  ICD11 = 'ICD11',
  ehr = 'ehr',
  adHocReports = 'adHocReports',
  reportSnapshots = 'reportSnapshots',
  serviceLineLevelBilling = 'serviceLineLevelBilling',
  customForms = 'customForms',
  turnOffTracks = 'turnOffTracks',
  deepgram = 'deepgram',
  memberships = 'memberships',
  aiReceptionist = 'aiReceptionist',
}

export enum FlagGroups {
  everyone = 'everyone',
  beta = 'beta',
  alpha = 'alpha',
  internal = 'internal',
}

export const flagGroupsArr = [
  {
    label: 'Internal',
    value: 'internal',
  },
  {
    label: 'Alpha',
    value: 'alpha',
  },
  {
    label: 'Beta',
    value: 'beta',
  },
  {
    label: 'Everyone',
    value: 'everyone',
  },
];
